import React, { useState, useEffect } from 'react';
import { supabase } from '../../supabaseClient';

const SubmitJob: React.FC = () => {
  const [data, setData] = useState('Sample text A, Sample text B');
  const [categories, setCategories] = useState('Category1, Category2, Category3');
  const [jobId, setJobId] = useState<string | null>(null);
  const [jobStatus, setJobStatus] = useState<string | null>(null);
  const [results, setResults] = useState<{ text: string; category: string }[] | null>(null);

  const handleSubmit = async () => {
    setJobStatus('submitting');
    setResults(null);

    const inputData = data?.split(',').map((s) => s.trim());
    const inputCategories = categories ? categories.split(',').map((s) => s.trim()) : undefined;

    const {
      data: { user },
      error: userError,
    } = await supabase.auth.getUser();
    if (userError || !user) return console.error('User not logged in');

    const {
      data: sessionData,
      error: sessionError,
    } = await supabase.auth.getSession();
    if (sessionError || !sessionData?.session?.access_token) return console.error('Access token not found');

    const accessToken = sessionData.session.access_token;

    const requestBody = {
      user_id: user.id,
      data: inputData,
      categories: inputCategories,
      is_static: true,
    };

    const response = await fetch(
      'https://ewfshbbhtmufjawhpved.supabase.co/functions/v1/forwardRequest',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(requestBody),
      }
    );

    if (!response.ok) {
      const err = await response.json();
      console.error('Submission failed:', err);
      setJobStatus('error');
      return;
    }

    const res = await response.json();
    setJobId(res.job_id);
    setJobStatus('queued');
  };

  useEffect(() => {
    if (!jobId) return;

    const interval = setInterval(async () => {
      const { data, error } = await supabase
        .from('jobs')
        .select('status, result_uri')
        .eq('id', jobId)
        .single();

      if (error) {
        console.error('Error checking job status:', error);
        clearInterval(interval);
        setJobStatus('error');
        return;
      }

      if (data?.status === 'done') {
        clearInterval(interval);
        setJobStatus('done');
        setResults(null); // results now stored in Storage
      } else if (data?.status === 'failed') {
        clearInterval(interval);
        setJobStatus('failed');
      } else {
        setJobStatus(data?.status);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [jobId]);

  return (
    <div>
      <h2>Submit Categorization Job</h2>
      <textarea
        placeholder="Enter data, separated by commas"
        value={data}
        onChange={(e) => setData(e.target.value)}
        style={{ width: '100%', height: '60px', marginBottom: '10px' }}
      />
      <input
        type="text"
        placeholder="Enter categories, separated by commas"
        value={categories}
        onChange={(e) => setCategories(e.target.value)}
        style={{ width: '100%', marginBottom: '10px' }}
      />
      <button onClick={handleSubmit} disabled={jobStatus === 'submitting'}>
        Submit Job
      </button>

      {jobStatus && <p>Status: {jobStatus}</p>}

      {results && (
        <table border={1} style={{ marginTop: '20px', width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr>
              <th>Text</th>
              <th>Category</th>
            </tr>
          </thead>
          <tbody>
            {results.map((r, i) => (
              <tr key={i}>
                <td>{r.text}</td>
                <td>{r.category}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default SubmitJob;
